import { defaultValues } from './model'
import { getRoleLabel } from 'constants/users'

export const mapInternalStateToPayload = (user, isEditMode) => {
  const { first_name, last_name, email, role, password, department } = user

  return {
    first_name,
    last_name,
    email,
    password,
    role: role.value,
    ...(isEditMode ? {} : { department: department.map(dep => dep.value) }),
  }
}

type UserPayload = {
  first_name?: string
  last_name?: string
  email?: string
  role?: number
}

export const mapPayloadToInternalState = (user: UserPayload = {}) => {
  const { first_name, last_name, email, role } = user

  return {
    first_name: first_name || defaultValues.first_name,
    last_name: last_name || defaultValues.last_name,
    email: email || defaultValues.email,
    role: role
      ? {
          value: role,
          label: getRoleLabel(role),
        }
      : defaultValues.role,
  }
}
